import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const KDSService = {
  orderList: async ({
    fromDate,
    toDate,
    tableId,
    productId,
    page = 1,
    pageSize = 1000,
    status,
  } = {}) => {
    const filterList = [];
    if (fromDate && fromDate.trim())
      filterList.push(`fromDate=${encodeURIComponent(fromDate.trim())}`);
    if (toDate && !isNaN(toDate))
      filterList.push(`toDate=${parseFloat(toDate)}`);
    if (tableId && !isNaN(tableId))
      filterList.push(`tableId=${parseFloat(tableId)}`);
    if (productId && !isNaN(productId))
      filterList.push(`productId=${parseInt(productId)}`);
    if (page) filterList.push(`Page=${page}`);
    if (pageSize) filterList.push(`PageSize=${pageSize}`);
    if (status) filterList.push(`status=${status}`);
    const filterString =
      filterList.length > 0 ? `?${filterList.join("&")}` : "";
    const response = await apiService.get(`/kitchen/pending-items/by-product${filterString}`, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),

      }
    });
    return response.data;
  },

  getAllOrder: async ({
    PageNumber = 1,
    PageSize = 1000,
    FromDate,
    ToDate,
    Status,
  } = {}) => {
    const filterList = [];
    if (FromDate && FromDate.trim())
      filterList.push(`FromDate=${encodeURIComponent(FromDate.trim())}`);
    if (ToDate && ToDate.trim())
      filterList.push(`ToDate=${encodeURIComponent(ToDate.trim())}`);
    if (Status && Status.trim())
      filterList.push(`Status=${encodeURIComponent(Status.trim())}`);
    if (PageNumber) filterList.push(`PageNumber=${PageNumber}`);
    if (PageSize) filterList.push(`PageSize=${PageSize}`);
    const filterString =
      filterList.length > 0 ? `?${filterList.join("&")}` : "";
    const response = await apiService.get(`/kitchen/mis-report${filterString}`, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  itemTheme: async (orgcode) => {
    const response = await apiService.get("/kitchen/pending-items/by-product", {
      headers: {
        APIKEY: orgcode, // pass orgcode in header instead of query param
      },
    });
    return response.data;
  },

  markPrepare: async (orderDetailId) => {
    const response = await apiService.post(
      `/kitchen/items/${orderDetailId}/mark-prepared`,
      {}, // <-- Empty request body
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
  markServe: async (orderDetailId) => {
    const response = await apiService.post(
      `/kitchen/items/${orderDetailId}/mark-served`,
      {}, // <-- Empty request body
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },


};

export default KDSService;
